import cx from 'classnames';

import { formatVehicleName } from 'Utilities/formatters';

import styles from './MakeAndModel.module.scss';

interface MakeAndModelProps {
	make: string;
	model: string;
	titleClassName?: string;
}

export const MakeAndModel: React.FC<MakeAndModelProps> = ({ make, model, titleClassName }) => {
	return (
		<section>
			<h4 className={cx(styles.title, titleClassName)} data-cy="makeAndModel">
				{formatVehicleName({ make, model })}
			</h4>
		</section>
	);
};
